import { motion } from "framer-motion";
import { PORTFOLIO } from "../data/content";
import { SectionHead } from "./Reveal";

export const Portfolio = () => (
  <section id="portfolio" className="relative py-28 lg:py-40" data-testid="portfolio-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <SectionHead
        eyebrow="Portfolio"
        lines={["Beispiele", "meiner Arbeiten."]}
        text="Amazon Listings, Ambiente-Bilder, Freisteller, technische Zeichnungen, Amazon A+ und Instagram – jedes Motiv individuell erstellt."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[300px] gap-4" data-testid="portfolio-grid">
        {PORTFOLIO.map((p, i) => (
          <motion.figure
            key={p.src}
            initial={{ opacity: 0, y: 40, clipPath: "inset(0 0 100% 0)" }}
            whileInView={{ opacity: 1, y: 0, clipPath: "inset(0 0 0% 0)" }}
            viewport={{ once: true, margin: "-8% 0px" }}
            transition={{ duration: 1.1, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`frame frame-corner group border border-[var(--line)] ${p.mobile} lg:aspect-auto ${p.span} ${p.light ? "bg-white" : "bg-[var(--bg-2)]"}`}
            data-testid={`portfolio-item-${i}`}
          >
            <img src={p.src} alt={p.label} className={`absolute inset-0 w-full h-full ${p.light ? "object-contain p-6" : `object-cover ${p.pos}`}`} loading="lazy" />
            {!p.light && <div className="veil" />}
            <figcaption className={`absolute bottom-0 inset-x-0 p-6 flex items-end justify-between ${p.light ? "bg-gradient-to-t from-white via-white/80 to-transparent" : ""}`}>
              <div>
                <p className={`font-mono text-[0.6rem] tracking-[0.2em] uppercase ${p.light ? "text-[var(--gold-dim)]" : "text-[var(--gold)]"}`}>{p.cat}</p>
                <p className={`font-display text-xl mt-1 ${p.light ? "text-[#0a0a0b]" : "text-[var(--text)]"}`}>{p.label}</p>
              </div>
              <span className={`font-mono text-[0.6rem] ${p.light ? "text-[#0a0a0b]/60" : "text-[var(--muted)]"}`}>0{i + 1}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
